import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerMultiTableTournamentsWidget } from '../../../../model';

import styles from './SortByDropdown.scss';
import type { SortByOptionProps } from './SortByOption/SortByOption';
import SortByOption from './SortByOption/SortByOption';
import OPTIONS from './options';

export interface SortByDropdownProps {
  show: boolean;
  onOptionSelect: SortByOptionProps['onClick'];
  onClose: () => void;
}

const SortByDropdown: React.FC<SortByDropdownProps> = ({ show, onOptionSelect, onClose }) => {
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const sortRule = useSelector(widgetSelect.getTableSortRule);

  return (
    <div className={classNames({ [styles.hidden]: !show })}>
      <div onClick={onClose} className={styles.overlay} />
      <div data-testid="sort-by-options" className={classNames(styles.sortByDropdown)}>
        {OPTIONS.map((option) => (
          <SortByOption
            key={option.id + option.desc.toString()}
            {...option}
            isSelected={sortRule.id === option.id && sortRule.desc === option.desc}
            onClick={onOptionSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default SortByDropdown;
